export default __webpack_public_path__ + "static/pragicts-secops-services-email-security-7c54537e3bc8628dbd245417f847944f.jpg";